// Translation file for SzakLetszamAdatok component
// Contains all UI text in Hungarian and English

export const SZAKLETSZAMADATOK_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.4 A hallgatók felvétele, előrehaladása, tanulmányaik elismerése és a képesítés odaítélése",
        pageTitle: "9. Szakra vonatkozó adatok",
        
        section91: {
            title: "9.1. Hallgatói létszámtrend (alapmutatók)",
            source: "Forrás:",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        section92: {
            title: "9.2. Kérjük jellemezze a hallgatók előrehaladását (abszolváltak az adott szakon átlagosan mennyi aktív félév alatt végeztek)",
            source: "Forrás:",
            info: "INFO: A teljes szak előrehaladási mutatója → nem egyes tantárgyak részletezése.",
            subtitle: "Előrehaladási arány (összefoglaló)",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        section93: {
            title: "9.3. Kérjük jellemezze a kritikus tárgyakat (tantárgy eredményességi kimutatás)",
            source: "Forrás:",
            info: "INFO: A tantárgy akkor kerül ide, ha:\n– magas bukási arány\n– alacsony OTHV átlag\n– sok panasz\n– oktatói/tanszéki jelzés\n– tananyag vagy vizsgarendszer-probléma",
            subtitle: "Problémás tantárgyak előfordulása",
            listLabel: "Listázandó (Kérjük a felsorolásnál a tantárgy nevét, és Neptunkódját adják meg):",
            typeLabel: "Problémák jellege (több válasz jelölhető)",
            typeNoteLabel: "Megjegyzés (opcionális):",
            interventionLabel: "Javasolt beavatkozások:",
        },
        
        section94: {
            title: "9.4. Kérjük jellemezze a hallgatók teljesítményét a korrigált kreditindex segítségével",
            source: "Forrás:",
            subtitle: "Teljesítmény értékelés"
        },
        
        section95: {
            title: "9.5. Felvételi adatok",
            subtitle: "A szakra jelentkezők és jelentkezések, valamint a felvett hallgatók adatainak elemzése, értékelése. Jelentkezőkre és felvettekre  vonatkozó adatok forrása:",
            source: "Forrás:",
            subtitle951: "Jelentkezési trend értékelése:",
            subtitle952: "A felvételi ponthatárok alakulása az elmúlt 5 évben:",
            subtitle953: "Felvettek munkarend szerinti trendje:",
            subtitle954: "Felvettek megoszlása finanszírozási forma szerint:",
            subtitle955: "A felvettek földrajzi megoszlása:",
            subsubtitle955: "Vonzáskörzet értékelése:"
        },
        
        section96: {
            title: "9.6. Diplomás pályakövetés adatok",
            source: "Forrás:",
            subtitle: "segítségével",
            subtitle961: "Diplomás foglalkoztatottság értékelése",
            subtitle962: "A végzettségének megfelelő szakmában dolgozók aránya",
            subtitle963: "Jövedelmi szint értékelése"
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
       esgTitle: "ESG 1.4 Admission, Progression, Recognition of Studies and Award of Qualifications",
        pageTitle: "9. Data related to the major",
        
        section91: {
            title: "9.1. Student Enrolment Trends (Key Indicators)",
            source: "Source:",
            noteLabel: "Comments (optional):",
        },
        
        section92: {
            title: "9.2. Please describe student progression within the programme (i.e. the average number of active semesters required for students who completed the programme)",
            source: "Source:",
            info: "Note: This indicator reflects overall programme-level progression and does not provide course-level details",
            subtitle: "Progression rate (summary)",
            noteLabel: "Comments (optional):",
        },
        
        section93: {
            title: "9.3. Please describe critical courses based on course performance reports",
            source: "Source:",
            info: "Note: A course is considered critical if one or more of the following apply:\n– High failure rate\n– Low average course evaluation (OTHV) score\n– High number of student complaints\n– Feedback from teaching staff or the department\n– Issues related to teaching materials or the examination system",
            subtitle: "Occurrence of problematic courses",
            listLabel: "Courses to be listed (Please specify the name of the course and its Neptun code in the list):",
            typeLabel: "Nature of identified issues (multiple answers may be selected)",
            typeNoteLabel: "Comments (optional):",
            interventionLabel: "Suggested actions:",
        },
        
        section94: {
            title: "9.4. Please assess student performance using the adjusted credit index",
            source: "Source:",
            subtitle: "Performance assessment"
        },
        
        section95: {
            title: "9.5 Admissions Data",
            subtitle: "Analysis and evaluation of data related to applicants, applications, and admitted students to the programme. Source of data on applicants and admitted students:",
            source: "Forrás:",
            subtitle951: "Assessment of application trends:",
            subtitle952: "Trends in admission score thresholds over the past five years:",
            subtitle953: "Trends by mode of study (admitted students)",
            subtitle954: "Distribution of admitted students by funding scheme",
            subtitle955: "Geographical distribution of admitted students",
            subsubtitle955:"Assessment of the catchment area"
        },
        
        section96: {
            title: "9.6. Graduate Tracking (Alumni Career Tracking) Data",
            subtitle: "Based on data from the Graduate Tracking System",
            source: "Source:",
            subtitle961: "Graduate employment rate assessment",
            subtitle962: "Professional relevance of employment",
            subtitle963: "Income level assessment"
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Undo Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
